import { useAuthStore } from "@/stores/user-auth";

// Проверка права пользователя
export async function hasPermisson(permission) {
    const authStore = useAuthStore();
    await authStore.getCurrentUser();
    return authStore.permissions.includes(permission);
}